import { mergeSx } from "@/utils/mergeSx";
import { Divider, type DividerProps } from "@mui/material";

export function SidemenuDivider({ sx, ...rest }: DividerProps) {
	return (
		<Divider sx={mergeSx({ marginInline: 1.25, opacity: 0.8 }, sx)} {...rest} />
	);
}
